module.exports = __webpack_public_path__ + "media/images/application/template/logos/visitengland-d1f59b637542a1f91ab1c9d9ce105fab.png";